import * as homeUrls from 'mk2/apps/home/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'home',
    exact: true,
    path: homeUrls.homepage,
    getPage: () => {
        return import('mk2/apps/home/containers/Home/HomePage' /* webpackChunkName: "home.Home" */);
    },
    modules: [ 'mk2/apps/home/containers/Home/HomePage' ],
}];
